import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { getBongoUrl } from '../../../common/utils/bongo';

export function useLinkedinIsConnected(tenant: number) {
  return useQuery<boolean>({
    queryKey: ['linkedin', tenant],
    queryFn: async () => {
      const { data } = await axios.get(
        `${getBongoUrl()}/v1/org/${tenant}/integrations/linkedin/ping`
      );

      return !!data?.valid;
    },
  });
}
